import { useRenderContext } from '../context';
import { TYPES } from '../../../utils/constants/shop/types';
import { SUPER, SUPERMARKET } from '../../../utils/constants/sections';

const SUPER_TYPES = [
  TYPES.SUPER,
  TYPES.SUPER_PARTNER,
];

const useSupermarketShop = () => {
  const { shopType, shopModel } = useRenderContext();

  const isSuper = shopType?.includes(SUPER);
  const isLandingSuper = shopType?.includes(TYPES.LANDING) && shopModel?.storefront?.tags?.includes(SUPERMARKET);

  const isSupermarketShop = isSuper || isLandingSuper;

  const shopWithActionsInEshopsItem = SUPER_TYPES.includes(shopType) || isLandingSuper;
  const shopWithCategorySuper = SUPER_TYPES.includes(shopType) || isLandingSuper;

  return {
    isSuper,
    isLandingSuper,
    isSupermarketShop,
    features: {
      shopWithActionsInEshopsItem,
      shopWithCategorySuper,
    },
  };
};

export { useSupermarketShop };
